import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Theme } from '@radix-ui/themes'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.dir = i18n.dir()
    document.documentElement.lang = i18n.language
  }, [i18n, i18n.language])

  // Set dark mode as default
  useEffect(() => {
    if (!document.documentElement.classList.contains('dark')) {
      document.documentElement.classList.add('dark')
    }
  }, [])

  return (
    <Theme
      style={{
        backgroundColor: 'var(--color-bg-app)',
        minHeight: '100vh'
      }}
    >
      {/* Hidden SVG gradient definitions — referenced by .icon-gradient */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          {/* Light mode: accent to tertiary (same as secondary-gradient-def) */}
          <linearGradient
            id="primary-gradient-def"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#de28a4" />
            <stop offset="100%" stopColor="#6b2a8c" />
          </linearGradient>
          {/* Dark mode: pale yellow to bright amber */}
          <linearGradient
            id="primary-gradient-def-dark"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#fffcbb" />
            <stop offset="100%" stopColor="#ffc534" />
          </linearGradient>
          {/* Secondary gradient — light mode: accent to tertiary */}
          <linearGradient
            id="secondary-gradient-def"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#de28a4" />
            <stop offset="100%" stopColor="#6b2a8c" />
          </linearGradient>
          {/* Secondary gradient — dark mode: accent to tertiary */}
          <linearGradient
            id="secondary-gradient-def-dark"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#de28a4" />
            <stop offset="100%" stopColor="#6b2a8c" />
          </linearGradient>
        </defs>
      </svg>
      <RouterProvider router={router} />
    </Theme>
  )
}

export default App
